export default {
  name: '',
  value: '',
}
